import { Field } from 'formik'
import React, { useState } from 'react'
import ResendPassword from './ResendPassword';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const NewUser = ({ values, touched, errors, loginType, timerForOtp, setTimerForOtp }) => {
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const togglePasswordVisibility = (type) => {
        if (type === 'NEW_PASSWORD') setShowNewPassword(!showNewPassword);
        if (type === 'CONFIRM_PASSWORD') setShowConfirmPassword(!showConfirmPassword);
    };
    return (
        <div>
            <div className="mb-4">
                <label htmlFor="userName" className="form-label">
                    Username *
                </label>
                <Field
                    type="text"
                    name="userName"
                    placeholder="Enter Username"
                    autoComplete="off"
                    disabled
                    className={`form-control ${touched.userName && errors.userName ? 'is-invalid' : ''}`}
                />
                {errors.userName && touched.userName && (
                    <p className="errorMsg">{errors.userName}</p>
                )}
            </div>
            {loginType?.step === 1 &&
                (
                    <>
                        <div className="mb-4">
                            <label htmlFor="newPassword" className="form-label">
                                New Password *
                            </label>
                            <div style={{ position: 'relative' }}>
                                <Field
                                    // type={showNewPassword ? 'text' : 'password'}
                                    type="text"
                                    name="newPassword"
                                    placeholder="Enter New Password"
                                    autoComplete="off"
                                    className={`form-control ${touched.newPassword && errors.newPassword ? 'is-invalid' : ''}`}
                                    style={{ WebkitTextSecurity: showNewPassword ? "" : "disc" }}

                                />
                                <button
                                    type="button"
                                    onClick={() => togglePasswordVisibility('NEW_PASSWORD')}
                                    style={{
                                        position: 'absolute',
                                        right: '22px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        border: 'none',
                                        background: 'none',
                                        cursor: 'pointer',
                                    }}
                                >
                                    {showNewPassword ? <FaEye style={{ color: 'rgb(27, 35, 84)' }} /> : <FaEyeSlash style={{ color: 'rgb(27, 35, 84)' }} />}
                                </button>
                            </div>
                            {errors.newPassword && touched.newPassword && (
                                <p className="errorMsg">{errors.newPassword}</p>
                            )}
                        </div>
                        <div className="mb-4">
                            <label htmlFor="confPassword" className="form-label">
                                Confirm Password *
                            </label>
                            <div style={{ position: 'relative' }}>
                                <Field
                                    // type={showConfirmPassword ? 'text' : 'password'}
                                    type="text"
                                    name="confPassword"
                                    placeholder="Enter Confirm Password"
                                    autoComplete="off"
                                    className={`form-control ${touched.confPassword && errors.confPassword ? 'is-invalid' : ''}`}
                                    style={{ WebkitTextSecurity: showConfirmPassword ? "" : "disc" }}
                                />
                                <button
                                    type="button"
                                    onClick={() => togglePasswordVisibility('CONFIRM_PASSWORD')}
                                    style={{
                                        position: 'absolute',
                                        right: '22px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        border: 'none',
                                        background: 'none',
                                        cursor: 'pointer',
                                    }}
                                >
                                    {showConfirmPassword ? <FaEye style={{ color: 'rgb(27, 35, 84)' }} /> : <FaEyeSlash style={{ color: 'rgb(27, 35, 84)' }} />}
                                </button>
                            </div>
                            {errors.confPassword && touched.confPassword && (
                                <p className="errorMsg">{errors.confPassword}</p>
                            )}
                        </div>
                    </>
                )
            }

            {loginType?.step === 2 &&
                <ResendPassword
                    values={values}
                    errors={errors}
                    touched={touched}
                    timerForOtp={timerForOtp}
                    setTimerForOtp={setTimerForOtp}
                    loginType={loginType}
                />
            }


        </div>
    )
}

export default NewUser